module.exports = __webpack_public_path__ + "static/media/user.caacd20b.svg";